import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import CeklistAlteplaseSvc from "@/services/CeklistAlteplase";

export interface CeklistAlteplaseItem {
  key: string;
  label: string;
}

@Module({ store, dynamic: true, namespaced: true, name: "ceklist-alteplase" })
class CeklistAlteplaseModule extends VuexModule {
  data: any = null;
  registerId: string | number | null = null;
  indikasiItems: CeklistAlteplaseItem[] = [];
  kontraItems: CeklistAlteplaseItem[] = [];
  loading = false;

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_REGISTER(val: string | number | null) {
    this.registerId = val;
  }

  @Mutation SET_MASTERS(val: any) {
    this.indikasiItems = val.indikasi || [];
    this.kontraItems = val.kontra_indikasi || [];
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async loadMasters() {
    if (this.indikasiItems.length && this.kontraItems.length) return;

    try {
      const dt = await CeklistAlteplaseSvc.masters();
      const { data } = dt.data;
      this.SET_MASTERS(data || {});
    } catch {
      // biarkan kosong; komponen menampilkan peringatan
    }
  }

  @Action async getByRegister(reg: string | number) {
    if (String(this.registerId) !== String(reg)) {
      this.SET_DATA(null);
    }

    this.SET_REGISTER(reg);
    this.SET_LOADING(true);

    try {
      const dt = await CeklistAlteplaseSvc.getByRegister(reg);
      const { data } = dt.data;

      if (String(this.registerId) === String(reg)) {
        this.SET_DATA(data || null);
      }
    } catch {
      if (String(this.registerId) === String(reg)) {
        this.SET_DATA(null);
      }
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATA(null);
    this.SET_REGISTER(null);
  }
}

export const storeCeklistAlteplase = getModule(CeklistAlteplaseModule);
